<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="50" cy="50" r="50" fill="white"/>
<path d="M68.5 48.4019C70.5 49.5566 70.5 52.4434 68.5 53.5981L38.5 70.9186C36.5 72.0733 34 70.6299 34 68.3205L34 33.6795C34 31.3701 36.5 29.9267 38.5 31.0814L68.5 48.4019Z" fill="black"/>
</svg>
